module.exports = __webpack_public_path__ + "static/img/jiqi-txt3.0767d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt3.png
// module id = BG+O
// module chunks = 0